import { Chip } from '@mui/material'
import React from 'react'
import styles from './SuggestionChips.module.css'
import { Optional } from '@pogokid/util'

export interface SuggestionChipsProps {
  suggestions: Optional<Suggestion>[]
  onClick: (suggestion: Suggestion) => void
}

export interface Suggestion {
  id: string
  label: string
}

export function SuggestionChips({
  suggestions,
  onClick,
}: SuggestionChipsProps) {
  return (
    <nav className={styles.SuggestionChips}>
      <ul className={styles.__list}>
        {suggestions.map((suggestion) =>
          suggestion ? (
            <li key={suggestion.id}>
              <Chip
                label={suggestion.label}
                size="small"
                onClick={() => onClick(suggestion)}
              />
            </li>
          ) : null
        )}
      </ul>
    </nav>
  )
}
